import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navigation from './sections/Navigation';
import HeroSection from './sections/HeroSection';
import InfoSection from './sections/InfoSection';
import ProductSection from './sections/ProductSection';
import SecuritySection from './sections/SecuritySection';
import GallerySection from './sections/GallerySection';
import SupportSection from './sections/SupportSection';
import FooterSection from './sections/FooterSection';
import ResearchPage from './pages/ResearchPage';
import ResearchProjectPage from './pages/ResearchProjectPage';

function HomePage() {
  return (
    <>
      <Navigation />
      <main>
        <HeroSection />
        <InfoSection />
        <ProductSection />
        <SecuritySection />
        <GallerySection />
        <SupportSection />
        <FooterSection />
      </main>
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/research" element={<ResearchPage />} />
          <Route path="/research/:projectId" element={<ResearchProjectPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
